import { render, staticRenderFns } from "./Snacks.vue?vue&type=template&id=59e76cfb&scoped=true&"
import script from "./Snacks.vue?vue&type=script&lang=js&"
export * from "./Snacks.vue?vue&type=script&lang=js&"
import style0 from "./Snacks.vue?vue&type=style&index=0&id=59e76cfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e76cfb",
  null
  
)

export default component.exports